const slug = (t) => t.toLowerCase().replace(/<[^>]+>/g, "").replace(/æ/g, "ae").replace(/ø/g, "o").replace(/å/g, "a").replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "").slice(0, 60) || "del";
const strip = (h) => h.replace(/<[^>]+>/g, " ").replace(/&nbsp;/g, " ").replace(/&amp;/g, "&").replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/\s+/g, " ").trim();

/** Sanitised HTML from the editor → anchored headings, a split after the opening paragraph for the pulled quote, rail items. */
export const richBody = (html) => {
  if (!html || !strip(html)) return null;
  const headings = [];
  const seen = new Set();
  const anchored = html.replace(/<h2>([\s\S]*?)<\/h2>/g, (_m, inner) => {
    let id = `del-${slug(inner)}`;
    while (seen.has(id)) id += "-2";
    seen.add(id);
    headings.push({ id, label: strip(inner) });
    return `<h2 id="${id}" class="scroll-mt-28">${inner}</h2>`;
  });
  const m = /^(\s*<p>[\s\S]*?<\/p>)([\s\S]*)$/.exec(anchored);
  const head = m ? m[1] : anchored;
  const tail = m ? m[2].trim() : "";
  const firstText = m ? strip(m[1]) : "";
  return { head, tail, headings, text: strip(html), dropcap: firstText.length >= 140 && !/^\S{1,5}\.\s/.test(firstText) };
};
